export default __webpack_public_path__ + "static/media/globe.a07c79ca.svg";